/**
 * @generated SignedSource<<a827e6b5b5f08802c47a46f85c434a23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CaddieConfirmationStatus = "CONFIRMED" | "UNCONFIRMED";
export type ManualPaymentStatus = "AUTO_CHARGE" | "MARKED_PAID" | "PAYMENT_EXPECTED";
export type NoShowStatus = "CHARGE" | "EXEMPT" | "PAID" | "PRESENT";
export type ClaimMemberRoundInBookingInput = {
  round: CreateMemberRoundInput;
  shareId: string;
};
export type CreateMemberRoundInput = {
  bookingIndex?: number | null | undefined;
  caddieConfirmationStatus?: CaddieConfirmationStatus | null | undefined;
  caddieId?: string | null | undefined;
  cartNumber?: string | null | undefined;
  checkedIn?: boolean | null | undefined;
  courseLayoutId?: string | null | undefined;
  index?: number | null | undefined;
  manualPaymentStatus?: ManualPaymentStatus | null | undefined;
  noShowStatus?: NoShowStatus | null | undefined;
  nonPlayingHost?: boolean | null | undefined;
  playerId?: string | null | undefined;
  postable?: boolean | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type useMemberJoinNonPrePaidBookingMutation$variables = {
  input: ClaimMemberRoundInBookingInput;
};
export type useMemberJoinNonPrePaidBookingMutation$data = {
  readonly claimMemberRoundInBooking: {
    readonly booking: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useMemberJoinNonPrePaidBookingMutation = {
  response: useMemberJoinNonPrePaidBookingMutation$data;
  variables: useMemberJoinNonPrePaidBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMemberJoinNonPrePaidBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClaimMemberRoundInBookingPayload",
        "kind": "LinkedField",
        "name": "claimMemberRoundInBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMemberJoinNonPrePaidBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClaimMemberRoundInBookingPayload",
        "kind": "LinkedField",
        "name": "claimMemberRoundInBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "56517fcfff513cc462ef9a1f10202bc7",
    "id": null,
    "metadata": {},
    "name": "useMemberJoinNonPrePaidBookingMutation",
    "operationKind": "mutation",
    "text": "mutation useMemberJoinNonPrePaidBookingMutation(\n  $input: ClaimMemberRoundInBookingInput!\n) {\n  claimMemberRoundInBooking(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    booking {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5df2b119da015e94d2e0455a6b89f1f8";

export default node;
